import { Fragment, h } from 'preact';
import Button from '../form/Button';
import { useCallback } from 'preact/hooks';
import { Job } from '../../model/Job';
import JobVariationItem from '../../model/JobVariationItem';
import { IconType } from '../media/Icon';
import currentTeam from '../../query/currentTeam';
import callOnCommandStatus from '../../effect/callOnCommandStatus';
import { CommandStatus } from '../../../../framework/type';
import { useReorderJobVariationItemCommand } from '../../command/reorderJobVariationItem';

interface Props {
  job: Job;
  variation: JobVariationItem;
  onRunning?(): any;
}

export default function MoveVariationItemUpButton({job, variation, onRunning}: Props) {
  const [command, reorderJobVariationItem] = useReorderJobVariationItemCommand();
  const prevItem = job.prevVariationItem(variation.id);
  const team = currentTeam();

  const click = useCallback((event: MouseEvent) => {
    event.stopPropagation();

    if (!!team && !!prevItem) {
      reorderJobVariationItem({
        teamId: team.id,
        jobId: job.id,
        variationId: variation.id,
        order: prevItem.order,
      })
    }
  }, [reorderJobVariationItem, job, team, variation, prevItem]);

  if (onRunning) {
    callOnCommandStatus(CommandStatus.RUNNING, command, onRunning);
  }

  return (
    <Fragment>
      <Button
        small={true}
        onClick={click}
        onlyIcon={IconType.MOVE_UP}
        readOnly={!prevItem}
        tooltip={`Move Item Up`}
      />
    </Fragment>
  )
}